/**
 */
export const CacheTime = {
  ONE_MINUTE: 1000 * 60,
  TWO_MINUTES: 1000 * 60 * 2,
  FIVE_MINUTES: 1000 * 60 * 5,
  TEN_MINUTES: 1000 * 60 * 10,
  THIRTY_MINUTES: 1000 * 60 * 30,
  ONE_HOUR: 1000 * 60 * 60,
  ONE_DAY: 1000 * 60 * 60 * 24,
  INFINITY: Infinity,
} as const;

export const CacheStrategy = {
  /**
   */
  user: {
    staleTime: CacheTime.TEN_MINUTES,
    gcTime: CacheTime.THIRTY_MINUTES,
  },

  /**
   */
  userPersona: {
    staleTime: CacheTime.THIRTY_MINUTES,
    gcTime: CacheTime.ONE_HOUR,
  },

  /**
   */
  treeList: {
    staleTime: CacheTime.TWO_MINUTES,
    gcTime: CacheTime.THIRTY_MINUTES,
  },

  /**
   */
  treeDetail: {
    staleTime: CacheTime.FIVE_MINUTES,
    gcTime: CacheTime.THIRTY_MINUTES,
  },

  /**
   */
  treeCounts: {
    staleTime: CacheTime.FIVE_MINUTES,
    gcTime: CacheTime.THIRTY_MINUTES,
  },

  /**
   */
  nodeContent: {
    staleTime: CacheTime.TWO_MINUTES,
    gcTime: CacheTime.TEN_MINUTES,
  },

  /**
   */
  branchOptions: {
    staleTime: CacheTime.ONE_MINUTE,
    gcTime: CacheTime.FIVE_MINUTES,
  },

  /**
   */
  contentDiscovery: {
    staleTime: CacheTime.TEN_MINUTES,
    gcTime: CacheTime.THIRTY_MINUTES,
  },

  /**
   */
  missions: {
    staleTime: CacheTime.TEN_MINUTES,
    gcTime: CacheTime.THIRTY_MINUTES,
  },

  /**
   */
  creditBalance: {
    staleTime: CacheTime.ONE_MINUTE,
    gcTime: CacheTime.FIVE_MINUTES,
  },

  /**
   */
  creditTransactions: {
    staleTime: CacheTime.FIVE_MINUTES,
    gcTime: CacheTime.THIRTY_MINUTES,
  },

  /**
   */
  static: {
    staleTime: CacheTime.ONE_HOUR,
    gcTime: CacheTime.ONE_DAY,
  },

  /**
   */
  realtime: {
    staleTime: 0,
    gcTime: CacheTime.ONE_MINUTE,
  },

  /**
   */
  timeline: {
    staleTime: CacheTime.TWO_MINUTES,
    gcTime: CacheTime.TEN_MINUTES,
  },

  /**
   */
  publications: {
    staleTime: CacheTime.TWO_MINUTES,
    gcTime: CacheTime.THIRTY_MINUTES,
  },

  /**
   */
  publicationDetail: {
    staleTime: CacheTime.FIVE_MINUTES,
    gcTime: CacheTime.THIRTY_MINUTES,
  },

  /**
   */
  batchStatus: {
    staleTime: 0,
    gcTime: CacheTime.ONE_MINUTE,
  },

  /**
   */
  skills: {
    staleTime: CacheTime.TEN_MINUTES,
    gcTime: CacheTime.THIRTY_MINUTES,
  },
} as const;

/**
 */
export const DefaultQueryOptions = {
  staleTime: CacheTime.FIVE_MINUTES,
  gcTime: CacheTime.THIRTY_MINUTES,
  retry: 1,
  refetchOnWindowFocus: false,
} as const;
